import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { extractUndefinedValue } from './extractUndefinedValue';
import { ECoworkingOfferType } from '../repositories/offer-card/entities/offer/OfferSchema';

export function getCoworkingOfferTypeByOffer(offer: IOfferSchema): ECoworkingOfferType | null {
  return extractUndefinedValue(offer.coworkingOfferType);
}
